"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* exported Taidoc_BLE_Device TD_SetDate TD_ClearRecords TD_TurnOff TD_CountRecords TD_ReadWeightRecord TD_ReadBPRecord TD_ReadDateRecordForUser */

var BleReaderTD = function (_BleReader) {
  _inherits(BleReaderTD, _BleReader);

  function BleReaderTD() {
    _classCallCheck(this, BleReaderTD);

    return _possibleConstructorReturn(this, (BleReaderTD.__proto__ || Object.getPrototypeOf(BleReaderTD)).apply(this, arguments));
  }

  _createClass(BleReaderTD, [{
    key: "onStartNotification",
    value: function onStartNotification(measurement_uuid) {

      this.commands = this.commandList();

      if (this.device.serialCheckRequired()) {
        this.commands = this.serialCommandList().concat(this.commands);
      }

      this.userRecordList = [null, {}, {}, {}, {}]; // room for 4 users, starting at 1

      this.currentCommand = null;
      this.reading = null;
      this.storageNumber = 0;
    }
  }, {
    key: "commandList",
    value: function commandList() {
      //Override
      return [];
    }
  }, {
    key: "serialCommandList",
    value: function serialCommandList() {
      return [new TD_ReadSerial1(this), new TD_ReadSerial2(this)];
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(arr) {
      this.setChecksum(arr);
      return new Uint8Array(arr);
    }
  }, {
    key: "setChecksum",
    value: function setChecksum(arr) {
      var checkSum = 0;
      for (var i = 0; i <= arr.length - 2; i += 1) {
        checkSum += arr[i];
      }
      arr[arr.length - 1] = checkSum & 255;
    }
  }, {
    key: "sendCommand",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(commmand, finish, delay) {
        var _this2 = this;

        var bReq;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.sleep(delay);

              case 2:
                bReq = this.makeRequest(commmand);

                console.log(this.readerName + " -- sending command");
                console.log(commmand);

                this.write(this.service_uuid, "00001524-1212-efde-1523-785feabcd123", bReq.buffer);

                if (finish) {
                  console.log("sendCommand finished.");
                  // the last command is to shut down the device, sometimes it is already shut down and
                  // the ble.write never returns. So we give it a couple seconds, then return the reading and
                  // close the connection
                  setTimeout(function () {
                    console.log("Calling successCallback");_this2.successCallback({ ok: true, readings: _this2.reading, reader: _this2.name });
                  }, 2000);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendCommand(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return sendCommand;
    }()
  }, {
    key: "pushCommand",
    value: function pushCommand(command) {
      this.commands.unshift(command);
    }
  }, {
    key: "handleResult",
    value: function handleResult(result) {
      console.log(this.readerName + "- -result");
      var rxCmd = new Uint8Array(result);
      rxCmd = Array.from(rxCmd);
      console.log(rxCmd);
      var delay = 500;
      if (this.currentCommand != null) {
        this.currentCommand.addResult(rxCmd);
      } else {
        delay = 2000; // first command needs a longer delay
      }

      if (this.currentCommand == null || this.currentCommand.done) {

        if (this.currentCommand && this.currentCommand.error != null) {
          this.failureCallback(this.currentCommand.error);
        } else {

          this.currentCommand = this.commands.shift();
          if (this.currentCommand == null) {
            this.successCallback({ ok: true, readings: this.reading, reader: this.name });
          } else {
            this.currentCommand.start(delay);
          }
        }
      }
    }
  }]);

  return BleReaderTD;
}(BleReader);

var Taidoc_BLE_Device = new JS.Class(BLE_Device, {

  initialize: function initialize(name, model_name, device_uuid) {
    var service_uuid = "00001523-1212-efde-1523-785feabcd123";
    var measurement_uuids = ["00001524-1212-efde-1523-785feabcd123"];
    var returnsFloatValue = false;

    return this.callSuper(name, model_name, device_uuid, service_uuid, measurement_uuids, { returnsFloatValue: returnsFloatValue });
  },

  makeReader: function makeReader() {
    return new BleReaderTD(this);
  }

});

var Taidoc_Command = new JS.Class({
  initialize: function initialize(reader) {
    this.reader = reader;
    this.device = reader.device;
    this.expectedResultLength = 8;
    this.done = false;
    this.error = null;
    this.result = [];
    this.lastCommand = false;
  },

  start: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(delay) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.reader.sendCommand(this.makeCommand(), this.lastCommand, delay));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function start(_x4) {
      return _ref2.apply(this, arguments);
    }

    return start;
  }(),

  addResult: function addResult(rxCmd) {
    this.result = this.result.concat(rxCmd);
    if (this.result.length >= this.expectedResultLength) {
      this.done = true;
      this.finishCommand();
    }
  },

  finishCommand: function finishCommand() {
    //overrride
  },

  makeCommand: function makeCommand() {
    //overrride
  }
});

var TD_SetDate = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    var cmd = [81, 51, 0, 0, 0, 0, 163, 0];
    var now = new Date();

    var year = now.getFullYear() - 2000;
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();

    cmd[2] = ((month & 7) << 5) + day;
    cmd[3] = (year << 1) + (month >> 3);
    cmd[4] = minute;
    cmd[5] = hour;

    return cmd;
  },
  finishCommand: function finishCommand() {
    console.log("date set");
  }
});

var TD_ClearRecords = new JS.Class(Taidoc_Command, {

  initialize: function initialize(reader, user) {
    this.user = user;

    return this.callSuper(reader);
  },

  makeCommand: function makeCommand() {
    var cmd = [81, 82, 0, 0, 0, 0, 163, 0];
    cmd[2] = this.user;
    return cmd;
  },
  finishCommand: function finishCommand() {
    console.log("records cleared");
  }
});

var TD_ClearBPRecords = new JS.Class(Taidoc_Command, {

  initialize: function initialize(reader, user) {
    this.user = user;

    return this.callSuper(reader);
  },

  makeCommand: function makeCommand() {
    var cmd = [81, 82, 0, 0, 0, 0, 163, 0];
    cmd[5] = this.user;
    return cmd;
  },
  finishCommand: function finishCommand() {
    console.log("bp records cleared");
  }
});

var TD_TurnOff = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    this.lastCommand = true;
    return [81, 80, 0, 0, 0, 0, 163, 0];
  },
  finishCommand: function finishCommand() {
    console.log("off");
  }
});

var TD_CountRecords = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    return [81, 43, 0, 0, 0, 0, 163, 0];
  },

  finishCommand: function finishCommand() {
    var storageNumber = (this.result[3] << 8) + this.result[2];
    var newestIndex = (this.result[5] << 8) + this.result[4];

    console.log("storageNumber: " + storageNumber);
    console.log("newestIndex: " + newestIndex);

    if (newestIndex == 65535) {
      newestIndex = 0;
      storageNumber = 0;
    }

    this.reader.storageNumber = storageNumber;
  }
});

var TD_BatteryStatus = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    console.log("SEND battery status");
    return [81, 70, 0, 0, 0, 0, 163, 0];
  },

  finishCommand: function finishCommand() {
    var batteryStatus = this.result[2];
    console.log("GOT battery status");
    console.log(batteryStatus);
    console.log(this.result);
    // 0 Not support
    // 1 Good
    // 2 Low
    // 3 Dead
    if (batteryStatus != 0) {
      this.reader.batteryStatus = batteryStatus;
    }
  }
});

var TD_ReadWeightRecord = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    this.expectedResultLength = 34;
    var cmd = [81, 113, 2, 0, 0, 163, 0];

    return cmd;
  },

  finishCommand: function finishCommand() {
    var day = this.result[6];
    var month = this.result[5];
    var year = this.result[4] + 2000;
    var minute = this.result[8];
    var hour = this.result[7];

    var date = new Date(year, month, day, hour, minute, 0, 0);

    var weight = ((this.result[16] << 8) + this.result[17]) * 0.1;
    var rounded = Math.round(weight * 10) / 10;
    weight = rounded.toFixed(1);

    console.log(date);
    console.log(weight);

    this.reader.reading = {
      valid: true,
      batteryStatus: this.reader.batteryStatus,
      date: date,
      readings: [{ main: true,
        measurements: [{ name: "wt", value: "" + weight, unit: 'kg', designations: [] }]
      }]
    };
  }
});

var TD_ReadBPRecord = new JS.Class(Taidoc_Command, {

  initialize: function initialize(reader, user, record) {
    this.user = user;
    this.record = record;

    return this.callSuper(reader);
  },

  makeCommand: function makeCommand() {
    var cmd = [81, 38, 0, 0, 0, 0, 163, 0];
    cmd[2] = this.record;
    cmd[5] = this.user;

    return cmd;
  },

  finishCommand: function finishCommand() {
    var userRecord = this.reader.userRecordList[this.user];
    userRecord.pressure_systolic = this.result[2];
    userRecord.pressure_diastolic = this.result[4];
    userRecord.pulse_rate = this.result[5];

    console.log("got bp: ");
    console.log(userRecord);

    if (this.user == 4) {
      var mostRecentRecord = null;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.reader.userRecordList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rec = _step.value;

          if (rec && rec.pressure_systolic != 0 && (mostRecentRecord == null || rec.time > mostRecentRecord.time)) {

            mostRecentRecord = rec;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (mostRecentRecord != null) {

        this.reader.reading = {
          valid: true,
          date: mostRecentRecord.date,
          batteryStatus: this.reader.batteryStatus,
          readings: [{ main: true,
            measurements: [{ name: "sbp", value: "" + mostRecentRecord.pressure_systolic, unit: 'mmhg', designations: [] }, { name: "dbp", value: "" + mostRecentRecord.pressure_diastolic, unit: 'mmhg', designations: [] }, { name: "hr", value: "" + mostRecentRecord.pulse_rate, unit: 'bpm', designations: [] }]
          }]
        };
      }
    }
  }
});

// 26
var TD_ReadTemperatureRecord = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    return [81, 38, 0, 0, 0, 0, 163, 0];
  },

  finishCommand: function finishCommand() {
    var temperature = new bigdecimal.BigDecimal("" + ((this.result[3] << 8) + this.result[2]) + "e-1");
    var ambientTemp = ((this.result[5] << 8) + this.result[4]) * 0.1;

    console.log(temperature.toString());
    console.log(ambientTemp);

    var unit = this.device._result_unit();

    this.reader.reading = {
      valid: true,
      date: new Date(),
      batteryStatus: this.reader.batteryStatus,
      readings: [{ main: true,
        measurements: [{ name: "temp", value: "" + temperature.toString(), unit: unit, designations: [] }]
      }]
    };
  }
});

var TD_ReadDateRecord = new JS.Class(Taidoc_Command, {
  initialize: function initialize(reader, user, record) {
    this.user = user;
    this.record = record;

    return this.callSuper(reader);
  },

  makeCommand: function makeCommand() {
    var cmd = [81, 37, 0, 0, 0, 0, 163, 0];
    cmd[2] = this.record;
    cmd[5] = this.user;

    return cmd;
  },

  finishCommand: function finishCommand() {
    var day = this.result[2] & 31;
    var month = (this.result[2] >> 5) + ((this.result[3] & 1) << 3);
    var year = (this.result[3] >> 1) + 2000;
    var minute = this.result[4] & 63;
    var hour = this.result[5] & 31;

    this.date = new Date(year, month - 1, day, hour, minute, 0, 0);
    this.reader.recordDate = this.date;
  }
});

var TD_ReadBPDateRecord = new JS.Class(TD_ReadDateRecord, {

  finishCommand: function finishCommand() {
    this.callSuper();

    var userRecord = this.reader.userRecordList[this.user];
    userRecord.user = this.user;
    userRecord.date = this.date;
    userRecord.time = this.date.getTime();

    console.log("got date: ");
    console.log(userRecord);
  }
});

var TD_ReadBGRecord = new JS.Class(Taidoc_Command, {
  initialize: function initialize(reader, user, record, numRecords) {
    this.user = user;
    this.record = record;
    this.numRecords = numRecords;

    return this.callSuper(reader);
  },

  makeCommand: function makeCommand() {
    var cmd = [81, 38, 0, 0, 0, 0, 163, 0];
    cmd[2] = this.record;
    cmd[5] = this.user;

    return cmd;
  },

  finishCommand: function finishCommand() {
    var progressMess = $t("interviews.sensor_status.reading_count").replace("{{count}}", "" + (this.numRecords - this.record)).replace("{{total}}", "" + this.numRecords);
    this.reader.progressCallback({ message: progressMess, percent_done: (this.numRecords - this.record) / this.numRecords * 100, reader: this.reader.name });

    var transmitted = false;
    if ((this.result[5] >> 6 & 1) == 1) {
      transmitted = true;
    }
    var glucoseValue = (this.result[3] << 8) + this.result[2];
    var ambientValue = this.result[4];
    var codeNo = this.result[5] & 63;
    var type = "General";
    switch (this.result[5] >> 6) {
      case 0:
        type = "AC";break;
      case 2:
        type = "PC";break;
      case 3:
        type = "QC";break;
      default:
        type = "General";break;
    }
    var type2 = "General";
    switch ((this.result[5] & 60) >> 2) {
      case 6:
        type2 = "hemato_critical";break;
      case 7:
        type2 = "ketone";break;
      default:
        type2 = "General";break;
    }

    console.log(this.reader.recordDate);
    console.log("transmitted: " + transmitted);
    console.log("BG: " + glucoseValue);
    console.log("AM: " + ambientValue);
    console.log("CO: " + codeNo);
    console.log("T1: " + type);
    console.log("T2: " + type2);

    var designations = [];
    if (type2 != "General") {
      designations.push(type2);
    }

    if (this.reader.reading == null) {
      this.reader.reading = { valid: true, readings: [], batteryStatus: this.reader.batteryStatus };
    }

    this.reader.reading.readings.unshift({ main: false,
      date: this.reader.recordDate,
      measurements: [{ name: "bg", value: "" + glucoseValue, unit: 'mg/dL', designations: designations }]
    });

    var max = this.reader.reading.readings[0];
    $.each(this.reader.reading.readings, function (i, reading) {
      reading.main = false;
      if (reading.date.getTime() >= max.date.getTime()) {
        max = reading;
      }
    });

    max.main = true;
    this.reader.reading.date = max.date;
  }
});

var TD_ReadSerial1 = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    console.log("SEND Serial");
    return [81, 39, 0, 0, 0, 0, 163, 0];
  },

  finishCommand: function finishCommand() {
    console.log("GOT Serial");
    console.log(this.result);
    this.reader.serial1 = this.result;
  }
});

var TD_ReadSerial2 = new JS.Class(Taidoc_Command, {
  makeCommand: function makeCommand() {
    console.log("SEND Serial 1");
    return [81, 40, 0, 0, 0, 0, 163, 0];
  },

  finishCommand: function finishCommand() {
    console.log("GOT Serial 2");
    console.log(this.result);
    this.reader.serial2 = this.result;
    var hi = this.result;
    var lo = this.reader.serial1;

    var bArray = [hi[5], hi[4], hi[3], hi[2], lo[5], lo[4], lo[3], lo[2]];
    var serial = ByteArrayConverter.byteArrayToHexString(bArray);

    if (!this.reader.checkSerialNumber(serial)) {
      this.done = true;
      this.error = { ok: false, unmatched_serial_number: true, error: "WRONG SERIAL NUMBER", reader: this.reader.name };
    }
  }
});